<template>
  <div v-if="visible" class="sd-query-panel no-select round-corner shadow" v-drag>
    <div class="sd-head-default between-flex moveable">
      <div class="head-title ">查询结果</div>
      <div @click="close"><svg-icon icon-class='close' class="sd-hover clickable"></svg-icon></div>
    </div>
    <div class="query-panel__body sd-body-default " @mousedown.stop="()=>{}">
      <el-select v-model='selected_' placeholder="请选择图层" value-key='id' size="small" style="width:100%;" @change="handleSelectLayerChange">
        <el-option v-for='item in data_' :key='item.id' :label='item.alias' :value='item' />
      </el-select>
      <ul v-if="selectFt_" class="attribute-panel">
        <li v-for="(field,index) in displayFields_" :key="index">
          <div class="field-name cell">
            {{ field.alias }}
          </div>
          <div class="field-value cell">
            <slot :name="field.name" :data="selectFt_.properties">
              <el-image 
                v-if="imageFields_.includes(field.name)" 
                :src="getImages(selectFt_.properties[field.name])[0] || ''" 
                :preview-src-list="getImages(selectFt_.properties[field.name])" 
                style="width:100%;height:150px;line-height: 150px;">
                <template v-slot:error><span>无</span></template>
              </el-image>
              <el-link v-else-if="linkFiedls_.includes(field.name)" type="primary" :href="getLink(selectFt_.properties[field.name],field.name)">
                {{getFieldValueMapping(field.name,selectFt_.properties[field.name])}}
              </el-link>
              <div v-else>{{getFieldValueMapping(field.name,selectFt_.properties[field.name])}}</div>
            </slot>
          </div>
        </li>
      </ul>
      <el-pagination 
        v-if="filterFeatures_" 
        small  
        layout="prev, pager, next"  
        :current-page="currentPage_"
        :page-size="1" 
        :total="filterFeatures_.length || 0"
        @current-change="handleCurrentChange"
        hide-on-single-page
        :pager-count='pagerCount'/>
      </div>
  </div>
</template>

<script>
import {  getTranslate } from "@/api/layer.js"
export default {
  name: 'SdQueryPanel',
  props: {
    visible: {
      type: Boolean,
      default() {
        return true
      },
    },
    pagerCount:{
      type:Number,
      default:7
    }
  },
  data() {
    return {
      data_:[],
      selected_:null,
      selectFt_:null,
      globFieldMapping_:{},
      globFieldValueMapping_:{},
      fieldMapping_:{},
      fieldValueMapping_:{},
      displayFields_:[],
      imageFields_:[],
      imageUrl_:'',
      linkFiedls_:[],
      linkUrl_:'',
      currentPage_:1,
      filterFeatures_:[]
    };
  },
  watch:{
    selectFt_(){
      this.$emit('select-changed',this.selectFt_)
    },
    visible(){
      this.$emit('select-changed',this.visible?this.selectFt_:null)
    }
  },
  created(){
    getTranslate().then(res=>{
      const jsonObj = this.tryGetJsonObject(res.data?.data[0].replaceStr)
      this.globFieldMapping = this.formatFieldMapping(jsonObj)
    })
    //获取全局字段值映射
    this.globFieldValueMapping = {}
  },
  mounted() {
    
  },
  beforeDestroy(){
    this.$emit('select-changed',null)
    this.clear()
  },
  methods: {
    handleCurrentChange(index){
      this.selectFt_ = this.filterFeatures_[index-1]
    },
    handleSelectLayerChange(){
      this.setDisplayLayer(this.selected_)
    },
    add(lyr){
      const {data,...layerInfo} = lyr
      this.data_.push(layerInfo)
      layerInfo.fieldMapping = Object.assign(data.fieldMapping || {},this.globFieldMapping),
      layerInfo.fieldValueMapping = Object.assign(data.fieldValueMapping || {},this.globFieldValueMapping)
      layerInfo.hideFields = data.hideFields ||[]
      layerInfo.imageFields = data.imgPosition || []
      layerInfo.imageUrl = data.imgUrl
      layerInfo.linkFields = data.linkFields
      layerInfo.linkUrl = data.linkUrl
      if (!this.selected_) {
        this.selected_ = layerInfo
        this.handleSelectLayerChange()
      }
      console.log("add",layerInfo);
    },
    clear(){
      this.data_=[]
      this.selected_=null
      this.filterFeatures_=[]
      this.selectFt_=null
      this.displayFields_ =[]
      this.currentPage_=1
    },
    close(){
      this.$emit('select-changed',null)
      this.$emit('update:visible', false)

    },
    setDisplayLayer(queryResult){
      if (!queryResult ) {
       
        return
      }
      this.fieldMapping_ = this.formatFieldMapping(queryResult.fieldMapping)
      this.fieldValueMapping_ = this.formatFieldMapping(queryResult.fieldValueMapping)
      this.filterFeatures_ = queryResult.features
      this.currentPage_=1
      if (this.filterFeatures_.length>0) {
        this.selectFt_ = this.filterFeatures_[0]
        const fields=this.getFields(this.selectFt_)
        this.displayFields_ = this.getDisplayFields(fields,queryResult.hideFields)

      }else{
        this.selectFt_ = null
        this.displayFields_ =[]
      }
      this.imageFields_ = queryResult.imageFields || []
      this.imageUrl_ = queryResult.imageUrl
      this.linkFiedls_ = queryResult.linkFields || []
      this.linkUrl_ = queryResult.linkUrl
    },
    getFields(feature){
      let fields = []
      if (feature) {
        fields = Object.keys(feature.properties)
      }
      return fields
    },
    getDisplayFields(fields,fiterFields){
      const hideFields = fiterFields || []
      const fieldObjs = []
      fields.forEach(field => {
        if (!hideFields.length || !hideFields.includes(field)) {
          fieldObjs.push({
            name:field,
            alias:this.getFieldMapping(field)
          })
        }
      })
      return fieldObjs
    }, 
    getFieldMapping(name){
      return this.fieldMapping_? this.fieldMapping_[name.toUpperCase()] || name : name
    },
    getFieldValueMapping(name,value){
      if (!name) {
        return value || ''
      }
      const valueMapping = this.fieldValueMapping_[name] || {}
      return valueMapping[value]? valueMapping[value] : value
    },
    getImages(str){
      const images = []
      if (str) {
        const arr =str.split(',')
        arr.forEach(item => {
          images.push(this.imageUrl_ + '/' + item)
        });
      }
      return images
    },
    getLink(item,field){
      return this.linkUrl_?this.linkUrl_.replace(`{${field}}`,item) :this.linkUrl_
    },
    formatFieldMapping(oldFieldMapping){
      //默认字段名称为大写
      const fieldMapping = {}
      if(oldFieldMapping){
        for(const [key,value] of Object.entries(oldFieldMapping)){
          fieldMapping[key.toUpperCase()] = value
        }
      }
      return fieldMapping
    },
    tryGetJsonObject(jsonStr){
      let obj = {}
      try{
        obj = JSON.parse(jsonStr)
      }catch(e){
        obj = {}
      }
      return obj
    },
  },
};
</script>
<style scoped>
.sd-query-panel{
  position: absolute;
  top: 80px;
  left: calc(100% - 370px);
  z-index: 50;
}
.query-panel__body{
  height:75vh;
  width: 350px;
  overflow-y: auto;
}
.attribute-panel{
  position: relative;
  height: calc(100% - 80px);
  width: 100%;
  margin-bottom: 10px;
  overflow-y: auto;
}
ul{
  margin: 0;
  padding: 0;
  width: 100%;
  
}
ul li{
  display: flex;
}
.cell{
  display: table-cell;
  border: 1px solid #ebeef5;
  word-break: break-all;
  padding:  5px;
  text-align: center;
}
.field-name{
  flex: 0 85px;
  background-color: rgba(184, 242, 250, 0.5)
}
.field-value{
  flex: 1;
}


</style>